import { Injectable } from '@angular/core';
import { BaseApi } from './base/base.api';
import { Filter } from '@/models/filter.model';
import { Pagination } from '@/models/pagination.model';
import { HttpParams } from '@angular/common/http';
import { BankBoletoAccount, Billing, CreateBoleto, InvoicingReport } from '@/models/billing.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class BillingApi extends BaseApi {
  async billings(filter?: Filter): Promise<Pagination<Billing>> {
    let params = new HttpParams();
    if (filter) {
      Object.keys(filter).forEach((key) => {
        params = params.append(key, filter[key as keyof Filter].toString());
      });
    }
    const response = await firstValueFrom(
      this.http.get<{ pagedQueryResult: Pagination<Billing> }>(
        `${this.url}/invoicing`,
        { params }
      )
    );

    return response.pagedQueryResult;
  }
  async billingsFilters(filter: any): Promise<Pagination<Billing>> {
    let params = new HttpParams();
    if (filter) {
      Object.keys(filter).forEach((key) => {
        const value = filter[key as keyof Filter];
        if (value !== null && value !== undefined && value !== '') {
          params = params.append(key, value.toString());
        }
      });
    }
    const response = await firstValueFrom(
      this.http.get<{ succeeded: boolean; data: Pagination<Billing> }>(
        `${this.url}/invoicing`,
        { params }
      )
    );
    
    return response.data;
  }

  billingContractGenerate(contractId: string): Promise<any> {
    return this.post(`${this.url}/invoicing/contract/generate`, { contractId: contractId });
  }

  billingProposalGenerate(proposalId: string): Promise<any> {
    return this.post(`${this.url}/invoicing/proposal/generate`, { proposalId: proposalId });
  }

  deleteBilling(billingId: string): Promise<any> {
    return this.delete(`${this.url}/invoicing/${billingId}`);
  }

  async getBankBoletoAccounts(): Promise<BankBoletoAccount[]> {
    const response = await firstValueFrom(
      this.http.get<{ succeeded: boolean; data: BankBoletoAccount[] }>(
        `${this.url}/invoice/invoicing/boleto/accounts`)
    );

    return response.data;
  }

  createBoleto(payload: CreateBoleto): Promise<any> {
    return this.post(`${this.url}/invoice/invoicing/boleto/generate`, payload);
  }

  generateNFe(billingId: string): Promise<any> {
    return this.post(`${this.url}/invoice/invoicing/nfse/generate/${billingId}`, {});
  }

  donwloadBilling(billingId: string): Promise<any> {
    return this.get(`${this.url}/invoicing/contract/${billingId}/pdf/generate`);
  }
  
  exportBillingNFe(billingId: string): Promise<any> {
    return this.post(`${this.url}/invoice/${billingId}/download`, {});
  }

  exportBillingBoleto(billingId: string): Promise<any> {
    return this.get(`${this.url}/invoice/invoicing/boleto/${billingId}/download`);
  }
  
  async downloadCommissionReport(payload: InvoicingReport): Promise<Blob> {
    const url = `${this.url}/invoicing/commission-report`;
    const blob$ = this.http.post(url, payload, {
      responseType: 'blob'
    });
    return firstValueFrom(blob$);
  }
}
